import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const ProductContext = createContext(null);

export function ProductProvider({ children }) {
  const [products, setProducts] = useState([]);
  const [selected, setSelected] = useState("all");

  useEffect(() => {
    if (!localStorage.getItem("token")) return;
    api.get("/products?limit=100").then((r) => setProducts(r.data.items)).catch(() => {});
  }, []);

  return (
    <ProductContext.Provider value={{ products, selected, setSelected }}>
      {children}
    </ProductContext.Provider>
  );
}

export const useProducts = () => useContext(ProductContext);
